var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading"},[_c('img',{style:(_vm.imageWidth),attrs:{"src":"/images/loading/loading-v1-100x100.gif"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }